{
	"dropzoneTitle": "Arraste e solte o arquivo aqui",
	"dropzoneSubtitle": "ou clique para selecionar o arquivo",
	"fileDetails": "Tipo de arquivo: {{fileType}} até {{fileSize}}",
	"downloadSample": "Baixar tabela exemplo",
	"downloadInvalidSheet": "Baixar tabela com erros",
	"errorImporting": "Não foi possível importar a tabela",
	"errorInvalidHeader": "As colunas da planilha não correspondem ao modelo esperado. Baixe um novo modelo e tente novamente.",
	"errorUnreadableFile": "Não foi possível ler o arquivo. Verifique se é um arquivo .xlsx válido e não está corrompido.",
	"errorEmptySheet": "A planilha está vazia.",
	"errorEmptyHeaderCell": "Há uma coluna sem título no cabeçalho. Use o modelo padrão e não deixe colunas sem nome.",
	"selectFile": "Selecione um arquivo",
	"selectAnotherFile": "Selecione outro arquivo",
	"invalidFileTitle": "O arquivo selecionado é inválido",
	"invalidFileReasonInvalidType": "Tipo de arquivo não suportado. Utilize arquivos {{formats}}.",
	"invalidFileReasonTooLarge": "O arquivo excede o tamanho máximo de {{maxSize}}.",
	"invalidFileReasonTooManyFiles": "Envie apenas {{maxFiles}} arquivo por vez.",
	"invalidFileReasonTooSmall": "O arquivo é menor do que o permitido.",
	"invalidFileReasonDefault": "Não foi possível importar o arquivo. Verifique os requisitos e tente novamente.",
	"confirmCloseDialog": {
		"title": "Sair da importação em massa",
		"description": "Tem certeza que deseja sair da importação em massa sem baixar a planilha de erros?",
		"descriptionStrong": "Você não poderá baixar ela novamente e perderá essa informação.",
		"cancel": "Sair da edição",
		"download": "Baixar tabela com erros"
	},
	"importNewFile": "Importar novo arquivo"
}
